import { z } from 'zod';

export type Faq = z.infer<typeof faqSchema>;

export const faqSchema = z.object({
  description: z.string(),
  updatedAt: z.string().datetime(),
  faqs: z.array(
    z.object({
      id: z.number(),
      question: z.string(),
      answer: z.string(),
    })
  ),
});
